module.exports = __webpack_public_path__ + "img/our-mission.90c1c4e7.jpg";